module.exports = __webpack_public_path__ + "static/logo-f3549c0dde7a1be27d2fa473ad596b9e.jpg";